import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";
import EventItem from "./EventItem";

const ExpandedBox = ({
  classes,
  events,
  open,
  anchorEl,
  date,
  expandItems,
  collapseItems,
  handelOpened,
  ...rest
}) => {
  return (
    <>
      <Box className={classes.expandBox} onClick={expandItems}>
        <Typography className={classes.expandBoxText} noWrap>
          {events.length - 3} more
        </Typography>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={collapseItems}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            borderRadius: 0,
            width: anchorEl?.clientWidth + 40,
            border: "1px solid #EEE",
            boxShadow: "0px 0px 30px 2px rgb(0 0 0 / 5%)",
          },
        }}
      >
        <Box style={{ position: "relative" }}>
          <CloseIcon
            className={classes.closeIcon}
            style={{ position: "absolute", right: 4, top: -2 }}
            onClick={collapseItems}
          />
          <Typography className={classes.expandedDisplayDate}>
            {date}
          </Typography>
          {events.map((event) => (
            <EventItem
              classes={classes}
              event={event}
              itemOpened={event.open}
              handelOpened={handelOpened}
              {...rest}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default ExpandedBox;
